import { render, staticRenderFns } from "./CardsCorps.vue?vue&type=template&id=5f856d0f&scoped=true&"
import script from "./CardsCorps.vue?vue&type=script&lang=js&"
export * from "./CardsCorps.vue?vue&type=script&lang=js&"
import style0 from "./CardsCorps.vue?vue&type=style&index=0&id=5f856d0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f856d0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VAlert,VCard,VCardText,VCol,VImg,VRow,VSkeletonLoader})
